import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer';


import { getAllFaqs } from '../api/auth/faqService';
//import { PreLoginUUID,PostLoginUUID,getToken,saveToken } from '../utils/auth';
function FAQs() {
  const [faqData, setFaqData] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    // Fetch FAQs from the backend API

    const fetchFaqs = async () => {
      try {
        const data = await getAllFaqs();
        setFaqData(data);
      } catch (error) {
        console.error("Error fetching FAQs:", error.message);
      }
    };
    fetchFaqs();
  }, []);



  const toggleAnswer = (index) => {
    setOpenIndex(prevIndex => (prevIndex === index ? null : index));
  };

  return (
    <div>
      <Header />

      {/* Breadcrumbs */}
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>FAQs</h2>
                <ul className="bread-list">
                  <li><NavLink to='/'>Home</NavLink></li>
                  <li><i className="icofont-simple-right" /></li>
                  <li className="active">FAQs</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <section style={{ padding: '40px 0', backgroundColor: '#f9f9f9' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 20px' }}>
          <h3 style={{ textAlign: 'center', marginBottom: '30px', color: 'blue', fontWeight: '600' }}>
            Frequently Asked Questions (FAQs)
          </h3>

          {faqData.length === 0 ? (
            <p style={{ textAlign: 'center', color: '#666' }}>No FAQs available at the moment.</p>
          ) : (
            faqData.map((faq, index) => (
              <div
                key={index}
                style={{
                  marginBottom: '20px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #ddd',
                  paddingBottom: '15px'
                }}
                onClick={() => toggleAnswer(index)}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <h5 style={{ marginBottom: '8px', color: '#333' }}>{faq.question}</h5>
                  <span style={{ fontSize: '20px', fontWeight: 'bold', color: '#555' }}>
                    {openIndex === index ? '−' : '+'}
                  </span>
                </div>
                {openIndex === index && (
                  <p style={{ marginTop: '10px', color: '#666' }}>{faq.answer}</p>
                )}
              </div>
            ))
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default FAQs;
